import { setLocation } from 'shared/slices/location';
import { TLocation } from 'shared/types/location';
import { updateRegion } from '../../jsonQuery';
import { TThunkAction } from 'shared/types/redux';

export const applyLocation =
  (location: TLocation | undefined): TThunkAction =>
  dispatch => {
    dispatch(setLocation(location));

    if (location) {
      dispatch(updateRegion(location));
    }
  };
